import { useContext } from 'react'

import { AuthContext, type AuthContextValue } from '@/lib/auth/auth-context'

/**
 * Hook único de leitura/escrita do estado de auth. Exposto separado do
 * Provider para satisfazer `react-refresh/only-export-components` (HMR
 * funciona melhor quando arquivos de componente só exportam componentes).
 */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) {
    throw new Error('useAuth() must be used inside <AuthProvider>')
  }
  return ctx
}
